module.exports = __webpack_public_path__ + "static/media/Buzz7.04be3e6b.jpg";